export default "__VITE_ASSET__b07c6f95__"